import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { ItemService } from '../../services/item.service';
import { Router } from '@angular/router';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-slots',
  templateUrl: './slots.component.html',
  styleUrls: ['./slots.component.css']
})
export class SlotsComponent implements OnInit {

  dataSource_adv_brands_tab;
  dataSource_adv_brands_days_tab;
  dataSource_adv_channel_tab;
  displayedColumns = ['brand', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof', 'active_days'];
  displayedColumns_day = ['day', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];
  displayedColumns_channel = ['channel', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];

  @ViewChild('sort1') sort1: MatSort;
  @ViewChild('sort2') sort2: MatSort;
  @ViewChild('sort3') sort3: MatSort;
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('paginator3') paginator3: MatPaginator;


  ngOnInit() {

    let parameters:any = { section_name: 'Advertisers', page_name: 'Slots'}
      this.itemService.logEvent('onPageView', parameters);

    if(this.itemService.remeberAdv) {
      this.itemService.selected_adv = this.itemService.remeberAdv;
    }
    // console.log(this.router.url);
    this.itemService.secondary_selected_adv = null;
    this.itemService.secondary_selected_adv_brand = null;
    this.itemService.selected_adv_channel = null;
    this.itemService.selected_cat = null;
    
    this.itemService.showSpinner = true;
    this.itemService.url = this.router.url;
    // this.itemService.dateChangeDetector();
    
        
    if(this.itemService.dataAvailable){
      // console.log('Advertisers Block');
      this.itemService.advertisers();
      this.itemService.showSpinner = false;
    } else {
      // console.log('Date Change Block');      
      this.itemService.dateChangeDetector();
    }
  }


  constructor(public itemService: ItemService, public router: Router) { }



  chart = [];

  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    
    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };




  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;
    // console.log(this.itemService.endDate);

    // dateChanged Function

    
    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


  
    let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Slots',
      advertiser:advertiserSelected,
      startDate: this.itemService.startDate,
      days: this.itemService.days,
      endDate: this.itemService.endDate,
    }
    this.itemService.logEvent('onDateChange', parameters);


    this.itemService.dateChangeDetector();

   
  }


  onChange(value) {

    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;

    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Slots',
      advertiser:value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.top_slots_chartforSlot.destroy();
    this.itemService.slots_ByBrandchart.destroy();
    this.itemService.slots_ByCategoryChart.destroy();
    this.itemService.slots_ByCompanyChart.destroy();

    this.itemService.selected_adv = value;
    this.itemService.selected_adv_brand = null;

  

    this.itemService.advertisers();

    


  }


 

  onChangeCategory(value) {
    this.itemService.slots_ByBrandchart.destroy();
    this.itemService.slots_ByCategoryChart.destroy();
    this.itemService.slots_ByCompanyChart.destroy();
    this.itemService.selected_toCompare_category = value;
    
    this.itemService.advertisers();

  }





}


// WEBPACK FOOTER //
// ./src/app/advertisers/slots/slots.component.ts